import {Icons} from "./Icons";
import {ReactComponent as IdHorizontalIcon} from "../../../../assets/themes/squareone/icons/identification.svg"
import {ReactComponent as IdVerticalIcon} from "../../../../assets/themes/squareone/icons/passport.svg"
import {ReactComponent as IntPassport} from "../../../../assets/themes/squareone/icons/international-passport.svg"
import {ReactComponent as SelfieIcon} from "../../../../assets/themes/squareone/icons/selfie-icon.svg"
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check.svg'
import { ReactComponent as UserIcon } from '../../../../assets/icons/user.svg'
import { ReactComponent as RefreshIcon } from '../../../../assets/icons/arrow-path.svg'

const SquareOneIcons: Icons = {
    idHorizontal: <IdHorizontalIcon/>,
    idVertical: <IdVerticalIcon/>,
    intPassport: <IntPassport/>,
    user: <UserIcon/>,
    check: <CheckIcon/>,
    refresh: <RefreshIcon/>,
    selfie: <SelfieIcon/>
}

export default SquareOneIcons